module.exports = __webpack_public_path__ + "static/img/7areaA_06.df17f67.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/通常使用/7areaA_06.png
// module id = 1046
// module chunks = 1